
<template lang="pug">
.wrap
  el-tabs(v-model="activeName", :before-leave="toggleTab")
    el-tab-pane(label="字段管理", name="first")
    el-tab-pane(label="模型关联", name="second")
    el-tab-pane(label="数据权限", name="third")
  matePage.content(ref="matePage", v-if="activeName === 'first'")
  relateSubform.content(ref="relateSubform", v-if="activeName === 'second'")
  authGroup.content(ref="authGroup", v-if="activeName === 'third'")
</template>

<script>
import matePage from "./metaPage.vue";
import relateSubform from "./relateSubform.vue";
import authGroup from "./authGroup.vue";
export default {
  components: { matePage, relateSubform, authGroup },
  data() {
    return {
      activeName: "first",
      nodeData: {}
    };
  },
  methods: {
    async beforeLeave() {
      const matePage = this.$refs.matePage;
      if (matePage && !matePage.isEqualOld) {
        await this.$confirm("您当前有尚未保存的数据,确定离开?", "警告", { type: "warning" });
      }
    },
    async toggleTab(val) {
      await this.beforeLeave();
      this.$nextTick().then(() => {
        this.handleClick(val);
      });
    },
    async handleClick(val) {
      await this.$nextTick();
      switch (val) {
        case "first":
          this.$refs.matePage.getcolumnList(this.nodeData);
          break;
        case "second":
          this.$refs.relateSubform.getcolumnList(this.nodeData);
          break;
        default:
          this.$refs.authGroup.init(this.nodeData);
          break;
      }
    },
    async getcolumnList(data) {
      this.activeName = "first";
      this.nodeData = data;
      this.$refs.matePage.getcolumnList(this.nodeData);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
}
.content{
  width: 100%;

  height: calc(100% - 51px);
}

/deep/.el-tabs__header {
  margin-bottom: 0;
}

/deep/.el-tabs__content {
  height: calc(100% - 40px);
}

/deep/.el-tab-pane {
  height: 100%;
  overflow: hidden;
}
</style>
